<template>
  <header class="page-header">
    <section class="page-header__container">
      <div class="page-header__breadcrumbs">
        <p>Accueil</p>
        <span>/</span>
      </div>

      <h1 class="page-header__banner">Design Démo</h1>
    </section>
  </header>
</template>

<script>
export default {
  name: 'ComponentDemoHeader'
}
</script>
